"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Philosophy() {
  const principles = [{
    label: "Transparent flat-fee"
  }, {
    label: "Permit-ready plans"
  }, {
    label: "Rapid turnaround"
  }];
  return <section data-section-id="9781" id="the-architectural-journey" className="bg-background text-foreground py-24 md:py-40 px-6 md:px-16 dark">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">

          {/* Image */}
          <div data-scroll-item className="lg:col-span-5 order-1">
            <div className="overflow-hidden rounded-lg shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711307/img/architectural_drafting_studio.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711307/img/architectural_drafting_studio.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711307/img/architectural_drafting_studio.webp-wvc-sizes" alt="Modern architectural drafting studio with clean lines and professional tools" loading="lazy" decoding="async" className="w-full h-full object-cover aspect-[4/5] lg:aspect-[3/2]" />
            </div>
          </div>

          {/* Text content */}
          <div className="lg:col-span-7 order-2 flex flex-col">

            <div data-scroll-item>
              <span className="font-default text-muted-foreground" style={{
              fontSize: "0.8125rem",
              fontWeight: 500,
              letterSpacing: "0.14em",
              textTransform: "uppercase"
            }}>
                Our Approach
              </span>
            </div>

            <h2 data-scroll-item className="font-default text-foreground mt-6" style={{
            fontSize: "clamp(2.125rem, 3.8vw, 3.5rem)",
            fontWeight: 600,
            letterSpacing: "-0.015em",
            lineHeight: 1.1
          }}>
              Design, <em className="italic">refined</em> for modern living
            </h2>

            <div className="mt-8 space-y-6 max-w-[560px]">
              <p data-scroll-item className="font-default text-muted-foreground" style={{
              fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
              fontWeight: 400,
              letterSpacing: "-0.005em",
              lineHeight: 1.7
            }}>
                At Acumen D&B, we believe high-quality residential architecture should be accessible. We combine contemporary design sensibilities with a pragmatic, client-focused process to bring your vision to life.
              </p>
              <p data-scroll-item className="font-default text-muted-foreground" style={{
              fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
              fontWeight: 400,
              letterSpacing: "-0.005em",
              lineHeight: 1.7
            }}>
                From challenging urban lots to custom new home builds, we provide comprehensive design solutions. Our process is built on clear communication, technical precision, and a commitment to delivering permit-ready results.
              </p>
            </div>

            <div data-scroll-item className="mt-10 flex flex-wrap items-center gap-x-4 gap-y-2">
              {principles.map((item, i) => <div key={i} className="flex items-center gap-x-4">
                  <span className="font-default text-foreground" style={{
                fontSize: "0.9375rem",
                fontWeight: 500,
                letterSpacing: "0em"
              }}>
                    {item.label}
                  </span>
                  {i < principles.length - 1 && <span aria-hidden="true" className="inline-block w-1 h-1 rounded-lg bg-border" />}
                </div>)}
            </div>

            <div data-scroll-item className="mt-10">
              <Button asChild className="rounded-lg h-12 px-7 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors duration-250">
                <Link to="/HomePage">
                  <span className="font-default" style={{
                  fontSize: "0.9375rem",
                  fontWeight: 500,
                  letterSpacing: "0.01em"
                }}>
                    Start your project
                  </span>
                  <ArrowRight className="size-4" aria-hidden="true" />
                </Link>
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>;
}